import { IconPropsType } from '..';

export const LuckyWinIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="general=default, betting=default, statuses=default, arrows=default, toggleables=default, signs=default, menus=default, casino=clover">
      <g
        id="clover 1"
        clipPath="url(#clip0_3_61)"
      >
        <g id="Group">
          <path
            id="Vector"
            d="M9.74109 9.17986L9.99289 9.42446L10.2447 9.17986C10.5037 8.92086 12.8202 6.65468 13.2807 5.89209C13.5828 5.39568 13.7195 4.89928 13.7195 4.28777C13.7195 2.78417 12.59 2 11.4749 2C10.8634 2 10.3526 2.20863 9.99289 2.60432C9.71951 2.30216 9.25908 2 8.51807 2C7.19433 2 6.27347 2.94245 6.27347 4.28777C6.27347 4.89928 6.41016 5.39568 6.71232 5.89209C7.18714 6.65468 9.4821 8.92806 9.74109 9.17986Z"
            fill="#8388A3"
          />
          <path
            id="Vector_2"
            d="M10.259 10.813L10.0072 10.5684L9.7554 10.813C9.49641 11.072 7.17986 13.3381 6.71943 14.1007C6.41727 14.5971 6.28058 15.0935 6.28058 15.7051C6.28058 17.2087 7.41007 17.9928 8.52518 17.9928C9.13669 17.9928 9.64749 17.7842 10.0072 17.3885C10.2806 17.6907 10.741 17.9928 11.4892 17.9928C12.8058 17.9928 13.7266 17.0504 13.7266 15.7051C13.7266 15.0935 13.5899 14.5971 13.2878 14.1007C12.813 13.3453 10.518 11.072 10.259 10.813Z"
            fill="#8388A3"
          />
          <path
            id="Vector_3"
            d="M17.3957 9.9928C17.6979 9.71942 18 9.25898 18 8.51078C18 7.19424 17.0576 6.27338 15.7123 6.27338C15.0936 6.27338 14.6043 6.41007 14.1079 6.71222C13.3453 7.17985 11.0792 9.47481 10.8202 9.7338L10.5756 9.9856L10.8202 10.2374C11.0792 10.4964 13.3453 12.8129 14.1079 13.2734C14.6043 13.5755 15.1007 13.7122 15.7123 13.7122C17.2159 13.7122 18 12.5827 18 11.4676C18 10.8633 17.7842 10.3525 17.3957 9.9928Z"
            fill="#8388A3"
          />
          <path
            id="Vector_4"
            d="M9.17986 10.259L9.42446 10.0072L9.17986 9.75543C8.92086 9.49644 6.65468 7.17989 5.89209 6.71946C5.39568 6.4173 4.89928 6.28061 4.28777 6.28061C2.78417 6.27342 2 7.40291 2 8.51802C2 9.12953 2.20863 9.64033 2.60432 10C2.30216 10.2806 2 10.741 2 11.4821C2 12.7986 2.94245 13.7195 4.28777 13.7195C4.90647 13.7195 5.39568 13.5828 5.89209 13.2806C6.65468 12.813 8.92806 10.518 9.17986 10.259Z"
            fill="#8388A3"
          />
        </g>
        <path
          id="Vector_5"
          d="M13.7195 13.7195C16.0648 17.4965 17.9929 17.9425 17.9929 17.9425V16.8634C18.0001 16.8706 15.8346 16.3957 13.7195 13.7195Z"
          fill="#8388A3"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3_61">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(2 2)"
        />
      </clipPath>
    </defs>
  </svg>
);
